import request from 'admin-ng/util/request-promise';
import {INVITATIONS} from '.';

export const all = params => request(INVITATIONS, 'get', params);
export const del = id => request(`${INVITATIONS}${id}`, 'del');
